import { useLanguage } from "@/context/LanguageContext";
import WhatsAppIcon from "@/components/WhatsAppIcon";
import { Phone, CalendarClock } from "lucide-react";
import { SITE, telHref, waHref, DEFAULT_WA_TEXT } from "@/config/site";
import { useEnquiry } from "@/context/EnquiryContext";

// Mobile-only sticky action bar. Page content uses bottom padding so this never
// covers content (see Layout).
export const MobileStickyBar = () => {
  const { t } = useLanguage();
  const { openEnquiry } = useEnquiry();
  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-40 md:hidden border-t border-slate-800 bg-[#071426]/97 backdrop-blur-md shadow-2xl"
      data-testid="mobile-sticky-bar"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="grid grid-cols-3 gap-2 p-2.5">
        <a
          href={telHref(SITE.phonePrimary.tel)}
          data-testid="mobile-sticky-call-button"
          className="flex flex-col items-center justify-center rounded-xl bg-sky-600 py-2 text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-300"
          aria-label={t("Call {phone}", { phone: SITE.phonePrimary.display })}
        >
          <Phone className="h-5 w-5" aria-hidden="true" />
          <span className="text-xs font-semibold mt-0.5">{t("Call")}</span>
        </a>
        <a
          href={waHref(SITE.phonePrimary.wa, t(DEFAULT_WA_TEXT))}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mobile-sticky-whatsapp-button"
          className="flex flex-col items-center justify-center rounded-xl bg-emerald-600 py-2 text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-300"
          aria-label={t("Message on WhatsApp")}
        >
          <WhatsAppIcon className="h-5 w-5" aria-hidden="true" />
          <span className="text-xs font-semibold mt-0.5">WhatsApp</span>
        </a>
        <button
          type="button"
          onClick={() => openEnquiry()}
          data-testid="mobile-sticky-enquire-button"
          className="flex flex-col items-center justify-center rounded-xl bg-amber-500 py-2 text-slate-950 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-300"
          aria-label={t("Open trip enquiry form")}
        >
          <CalendarClock className="h-5 w-5" aria-hidden="true" />
          <span className="text-xs font-bold mt-0.5">{t("Book / Quote")}</span>
        </button>
      </div>
    </div>
  );
};
